var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('huo-mask',[_c('pop',{attrs:{"hdImg":"https://vfiles.gtimg.cn/vupload/202006/bb7aea1591074910581.png"},on:{"close":function($event){_vm.visible = false}}},[_c('rule-pop')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }